import React from 'react';
import cx from 'classnames';
import markdownit from 'markdown-it'

import { FontAwesomeIcon } from '@magoosh/lib/icons';
import usePathname from '@magoosh/utils/use_pathname';

import { useAITutorContext } from '@test_prep/app/ai_tutor/context';
import { Activity } from '@test_prep/app/ai_tutor/types';

import ErrorMessage from '../error_message';

import style from './style.module.scss';
import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  activity: Activity;
  onClick: () => void;
}

export default (props: Props) => {
  // This component is used by admin outside of the AITutor context. The AITutor context
  // isn't important in admin so just try/catch to avoid a javascript error.
  let activity = null;
  try { activity = useAITutorContext().activity } catch {};

  const pathname = usePathname();

  const interactionPart = props.activity.interactionPart;
  const isCurrentActivity = interactionPart.id === activity?.interactionPart?.id;
  const readOnly = props.activity.interaction.path !== pathname;

  const statusText = () => {
    if (interactionPart.status !== 'finished') {
      return 'Generating';
    }

    const answer = interactionPart.activityContent.answer;

    if (!readOnly && !answer && isCurrentActivity) {
      return 'Answering';
    } else if (!answer) {
      return 'Unanswered';
    } else if (answer.isCorrect) {
      return 'Correct!';
    } else {
      return 'Incorrect';
    }
  };

  if (interactionPart.status === 'error') {
    return <ErrorMessage message="Oops! Something went wrong generating a similar question." />;
  } else {
    return (
      <div className="u-padding-A-s"
        style={{
          backgroundColor: isCurrentActivity ? colors.alertInfoBg : '#ffffff',
          borderRadius: 8,
          transition: 'background-color 0.2s ease-in'
        }}
      >
        <div className={style.textDivider}>
          <div
            className="align-items-center d-flex flex-column gap-xxs u-padding-H-s"
            onClick={props.onClick}
            style={{
              cursor: 'pointer'
            }}
          >
            <div className="align-items-center d-flex gap-xs">
              {
                interactionPart.status === 'finished' ? (
                  <FontAwesomeIcon
                    icon="bolt"
                    style={{
                      background: '-webkit-linear-gradient(135deg, #26B67C, #9B51E0)',
                      fontSize: 20,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}
                  />
                ) : (
                  <div className={cx(style.animatedEllipsis, 'u-padding-V-xs')}>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                )
              }

              <div style={{ fontSize: 12 }}>
                <strong>{statusText()}</strong>
              </div>
            </div>

            <div>
              <strong>{interactionPart.name}</strong>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
